import { AsyncPipe } from '@angular/common';

import { Component, ChangeDetectionStrategy, Type } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';

import {
  FormlyFieldSelectProps,
  FormlySelectModule,
} from '@ngx-formly/core/select';

import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';

import { MultiSelectModule } from 'primeng/multiselect';

import { Select } from 'primeng/select';
import { LanguagePipe } from '../../pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { multiLangFilterBy } from '../../utils/multilang-filter.util';

interface SelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  appendTo?: Select['appendTo'];
  filter?: boolean;
  filterBy?: string;
  multiLang?: boolean;
}

export interface FormlySelectFieldConfig
  extends FormlyFieldConfig<SelectProps> {
  type: 'multiselect' | Type<TypeMultiSelect>;
}

@Component({
  selector: 'lib-type-multiselect',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MultiSelectModule,
    FormlyModule,
    FormlySelectModule,
    AsyncPipe,
    LanguagePipe,
    TranslocoPipe,
  ],
  template: `
    <p-multiselect
      [placeholder]="props.placeholder | transloco"
      [options]="(props.options | formlySelectOptions: field | async) || []"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [showClear]="!props.required"
      [appendTo]="props.appendTo"
      [filter]="props.filter"
      [filterBy]="resolveFilterBy()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      styleClass="min-w-[180px]"
      (onChange)="props.change && props.change(field, $event)"
      fluid
    >
      @if (props.multiLang) {
        <ng-template let-value pTemplate="selectedItems">
          <span style="white-space: normal;"
            >{{ value?.length }} {{ 'items_selected' | transloco }}</span
          >
        </ng-template>
        <ng-template let-item #item>
          <span style="white-space: normal;">{{
            item.label | languagePipe | async
          }}</span>
        </ng-template>
      }
    </p-multiselect>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeMultiSelect extends FieldType<FieldTypeConfig<SelectProps>> {
  resolveFilterBy(): string {
    if (this.props.filterBy) {
      return this.props.filterBy;
    }
    if (this.props.multiLang) {
      return multiLangFilterBy('label');
    }
    return 'label';
  }
}
